// Module
var code = `<i class="fa" ng-class="{
  'fa-angle-double-down': expandButtonController.isOpen,
  'fa-angle-double-right': !expandButtonController.isOpen
}"></i> `;
// Exports
module.exports = code;